import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-70">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-71">
          <motion.div className="absolute inset-0 bg-black/70 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} data-id="element-72" />
          <motion.div className="relative bg-night-900 border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} data-id="element-73">
            <div className="flex items-center justify-between p-5 border-b border-white/10" data-id="element-74">
              <h2 className="text-lg font-semibold text-white" data-id="element-75">{title}</h2>
              <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-white/10 transition-colors text-slate-400 hover:text-white" data-id="element-76">
                <XIcon className="w-5 h-5" data-id="element-77" />
              </button>
            </div>
            <div className="p-5 md:p-6 overflow-y-auto max-h-[calc(80vh-64px)] text-sm text-slate-300 leading-relaxed space-y-4" data-id="element-78">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="w-full bg-night-950 text-slate-500 py-8 px-6 text-center text-sm border-t border-white/10" data-id="element-79">
        <div className="max-w-4xl mx-auto" data-id="element-80">
          <p data-id="element-81">
            © {new Date().getFullYear()} Mente en Calma. Todos los derechos
            reservados.
          </p>
          <div className="mt-3 flex items-center justify-center gap-4 text-xs" data-id="element-82">
            <button onClick={() => setShowTerms(true)} className="text-slate-500 hover:text-purple-400 transition-colors underline underline-offset-2" data-id="element-83">
              Términos y Condiciones
            </button>
            <span className="text-slate-700" data-id="element-84">|</span>
            <button onClick={() => setShowPrivacy(true)} className="text-slate-500 hover:text-purple-400 transition-colors underline underline-offset-2" data-id="element-85">
              Política de Privacidad
            </button>
          </div>
          <p className="mt-3 text-xs text-slate-600" data-id="element-86">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Términos y Condiciones Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-87">
        <p className="font-semibold text-white" data-id="element-88">
          Última actualización: Marzo 2026
        </p>
        <p data-id="element-89">
          Al acceder y utilizar este sitio web y adquirir el producto digital
          "Mente en Calma", aceptas los siguientes términos y condiciones.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-90">1. Producto Digital</h3>
        <p data-id="element-91">
          "Mente en Calma" es un producto digital en formato PDF. Al completar
          tu compra, recibirás acceso inmediato para descargar el material.
          Debido a la naturaleza digital del producto, no se realizan envíos
          físicos.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-92">
          2. Garantía de Satisfacción
        </h3>
        <p data-id="element-93">
          Ofrecemos una garantía de devolución de 7 días a partir de la fecha de
          compra. Si no estás satisfecha con el producto, puedes solicitar un
          reembolso completo dentro de este período contactándonos por correo
          electrónico.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-94">3. Uso del Producto</h3>
        <p data-id="element-95">
          El contenido de "Mente en Calma" es para uso personal únicamente.
          Queda prohibida la reproducción, distribución, modificación o reventa
          del material sin autorización expresa por escrito.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-96">
          4. Descargo de Responsabilidad
        </h3>
        <p data-id="element-97">
          El contenido de esta guía es informativo y educativo. No sustituye el
          consejo médico profesional. Si padeces trastornos del sueño severos o
          condiciones médicas, consulta a un profesional de la salud antes de
          implementar cualquier protocolo.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-98">
          5. Propiedad Intelectual
        </h3>
        <p data-id="element-99">
          Todo el contenido, diseño, textos e imágenes de este sitio web y del
          producto son propiedad de Mente en Calma y están protegidos por las
          leyes de propiedad intelectual aplicables.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-100">6. Modificaciones</h3>
        <p data-id="element-101">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          este sitio web.
        </p>
      </LegalModal>

      {/* Política de Privacidad Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-102">
        <p className="font-semibold text-white" data-id="element-103">
          Última actualización: Marzo 2026
        </p>
        <p data-id="element-104">
          Tu privacidad es importante para nosotros. Esta política describe cómo
          recopilamos, usamos y protegemos tu información personal.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-105">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-106">
          Recopilamos la información que nos proporcionas voluntariamente al
          realizar una compra, incluyendo: nombre, dirección de correo
          electrónico e información de pago. La información de pago es procesada
          de forma segura por nuestro procesador de pagos y no almacenamos datos
          de tarjetas de crédito.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-107">
          2. Uso de la Información
        </h3>
        <p data-id="element-108">
          Utilizamos tu información para: procesar tu compra y entregar el
          producto digital, enviarte el enlace de descarga y confirmación de
          compra, comunicarnos contigo sobre tu pedido o soporte, y enviarte
          información relevante sobre actualizaciones del producto (solo si das
          tu consentimiento).
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-109">
          3. Protección de Datos
        </h3>
        <p data-id="element-110">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-111">4. Cookies</h3>
        <p data-id="element-112">
          Este sitio puede utilizar cookies para mejorar la experiencia del
          usuario y con fines analíticos. Puedes configurar tu navegador para
          rechazar cookies, aunque esto podría afectar la funcionalidad del
          sitio.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-113">5. Terceros</h3>
        <p data-id="element-114">
          No vendemos, comercializamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          asisten en la operación del sitio web y el procesamiento de pagos,
          siempre que dichas partes acuerden mantener esta información
          confidencial.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-115">6. Tus Derechos</h3>
        <p data-id="element-116">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal. Para ejercer estos derechos, contáctanos por correo
          electrónico.
        </p>
        <h3 className="text-white font-semibold mt-2" data-id="element-117">7. Contacto</h3>
        <p data-id="element-118">
          Si tienes preguntas sobre esta política de privacidad, puedes
          contactarnos a través de nuestro correo electrónico de soporte.
        </p>
      </LegalModal>
    </>;
}